<script setup lang="ts">
import { computed } from 'vue'
import AdvancedSettings from './AdvancedSettings.vue'
import BinaryReferencePicker from './BinaryReferencePicker.vue'
import type { SplitServiceModel, BinaryReference } from '@/types'

const props = defineProps<{
  modelValue: SplitServiceModel
}>()

const emit = defineEmits<{
  'update:modelValue': [value: SplitServiceModel]
}>()

const EMPTY_REFERENCE: BinaryReference = { serviceId: '', projection: 'Output', path: [] }

// Split's source is binary-only (ADR-018/ADR-034) — an inline expression array cannot be streamed,
// so there is no Expression⇄Binary toggle. A non-binary or absent source shows the empty picker.
const reference = computed<BinaryReference>(() =>
  props.modelValue.source?.$type === 'binary'
    ? props.modelValue.source.reference
    : { ...EMPTY_REFERENCE },
)

function update(value: BinaryReference) {
  emit('update:modelValue', { ...props.modelValue, source: { $type: 'binary', reference: value } })
}
</script>

<template>
  <div class="mb-3">
    <label class="form-label">Source array</label>
    <BinaryReferencePicker :model-value="reference" @update:model-value="update" />
    <div class="form-text">
      The upstream array to fan out — one branch runs per element. Reference an upstream service's
      output, or drill to an array within it.
    </div>
    <AdvancedSettings />
  </div>
</template>
